import { useState, useEffect } from 'react'
import {
  onAuthStateChanged,
  signOut as firebaseSignOut,
  signInWithPopup,
  GoogleAuthProvider,
  browserPopupRedirectResolver,
  signInWithCustomToken as firebaseSignInWithCustomToken,
  type User,
} from 'firebase/auth'
import { auth, isFirebaseAvailable } from '../lib/firebase'

export function useAuth() {
  const [user, setUser]       = useState<User | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!isFirebaseAvailable || !auth) {
      setLoading(false)
      return
    }
    const unsub = onAuthStateChanged(auth, u => {
      setUser(u)
      setLoading(false)
    })
    return unsub
  }, [])

  async function signInWithCustomToken(customToken: string): Promise<User> {
    if (!auth) throw new Error('Authentication not configured')
    const cred = await firebaseSignInWithCustomToken(auth, customToken)
    return cred.user
  }

  async function signInWithGoogle(): Promise<void> {
    if (!auth) throw new Error('Authentication not configured')
    const provider = new GoogleAuthProvider()
    // Pass the resolver here (not globally) so the auth iframe only loads when
    // Google popup sign-in is actually used — keeping it off every page load.
    await signInWithPopup(auth, provider, browserPopupRedirectResolver)
  }

  async function signOut(): Promise<void> {
    if (!auth) return
    await firebaseSignOut(auth)
  }

  return {
    user,
    loading,
    signInWithCustomToken,
    signInWithGoogle,
    signOut,
  }
}
